import React, { ReactNode } from 'react';
import { Row, Col, Button, Dropdown } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

import { ReactComponent as ActionSvg } from '@assets/icons/action.svg';
import { ReactComponent as CrossSvg } from '@assets/icons/cross-xs.svg';

import './PanelSection.less';

interface PanelSectionProps {
  name: string;
  count?: number;
  dropdownMenu?: ItemType[] | null;
  extraction?: React.ReactElement | null;
  onDropdownHandler?(key: string): void;
  onClose?(): void;
  children: ReactNode;
}

function PanelHeader({
  name,
  count,
  extraction,
  dropdownMenu,
  onClose,
  onDropdownHandler
}: {
  name: string;
  count: number | null;
  dropdownMenu: ItemType[] | null;
  extraction: React.ReactElement | null;
  onClose?(): void;
  onDropdownHandler: ((key: string) => void) | null;
}) {
  return (
    <Row
      className="panel-section_head"
      wrap={false}
      justify="space-between"
      align="middle"
    >
      <Col>
        <Row gutter={8} align="middle">
          <Col>{name}</Col>
          {count ? (
            <Col>
              <div className="panel-section_head-label">{count}</div>
            </Col>
          ) : (
            ''
          )}
        </Row>
      </Col>
      <Col className="panel-section_head-actions">
        <Row gutter={16} align="middle" wrap={false}>
          {extraction && <Col>{extraction}</Col>}
          {dropdownMenu && (
            <Col>
              <Dropdown
                menu={{
                  onClick: ({
                    key,
                    domEvent
                  }: {
                    key: string;
                    domEvent: any;
                  }) => {
                    domEvent.stopPropagation();
                    if (onDropdownHandler) {
                      onDropdownHandler(key);
                    }
                  },
                  selectable: false,
                  items: dropdownMenu
                }}
                prefixCls="media_viewer_menu"
                overlayClassName="panel-section_head-overlay"
                placement="bottomRight"
                trigger={['click']}
              >
                <Button
                  className="media_viewer_btn b-only-icon"
                  onClick={(event) => event.stopPropagation()}
                >
                  <ActionSvg className="b-white-icon" />
                </Button>
              </Dropdown>
            </Col>
          )}
          {!!onClose && (
            <Col>
              <Button
                className="media_viewer_btn b-only-icon"
                onClick={onClose}
              >
                <CrossSvg className="b-white-icon" width={20} height={20} />
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
}

function PanelSection({
  name,
  count,
  extraction,
  onDropdownHandler,
  onClose,
  dropdownMenu,
  children
}: PanelSectionProps) {
  return (
    <div className="panel-section">
      <PanelHeader
        name={name}
        count={count || null}
        extraction={extraction || null}
        dropdownMenu={dropdownMenu || null}
        onDropdownHandler={onDropdownHandler || null}
        onClose={onClose}
      />
      {children}
    </div>
  );
}

export default PanelSection;
